import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import styles from './Footer.module.css'
import LanguageSwitcher from './LanguageSwitcher'
import { useI18n } from '../lib/i18n'

const COLUMN_TITLES = {
  company: 'footer.company',
  products: 'footer.products',
  services: 'footer.services',
  legal: 'footer.legal',
}

const Footer = () => {
  const { t } = useI18n()
  const [year] = useState(() => new Date().getFullYear())

  return (
    <footer className={styles.footer}>
      <div className="rule-ink" aria-hidden="true" />
      <div className={`container ${styles.footerContainer}`}>
        <div className={styles.brand}>
          <div className={styles.brandHead}>
            <span className={styles.indexMark} aria-hidden="true" />
            <h2 className={styles.brandName}>OPRAIZ</h2>
          </div>
          <p className={styles.tagline}>{t('footer.tagline')}</p>
          <p className={styles.description}>
            Opraiz.com owned by Opraiz Technology Pvt. Ltd. R&amp;D by{' '}
            <a
              href="https://www.opraizfoundry.com"
              className={styles.foundryLink}
              target="_blank"
              rel="noreferrer noopener"
            >
              Opraiz Foundry
            </a>
          </p>
          <span className={`badge badge--neutral ${styles.brandChip}`}>
            <Sparkles size={13} aria-hidden="true" />
            Powered by Baanzon AI
          </span>
        </div>

        <nav className={styles.links} aria-label="Footer">
          <div className={styles.column}>
            <h3 className={styles.colTitle}>{t(COLUMN_TITLES.company)}</h3>
            <Link to="/company">{t('footer.about')}</Link>
            <Link to="/products">{t('footer.industries')}</Link>
            <Link to="/pricing">{t('footer.pricing')}</Link>
            <Link to="/blog">{t('footer.blog')}</Link>
            <Link to="/changelog">{t('footer.changelog')}</Link>
            <Link to="/integrations">{t('footer.integrations')}</Link>
            <Link to="/account">{t('footer.account')}</Link>
          </div>
          <div className={styles.column}>
            <h3 className={styles.colTitle}>{t(COLUMN_TITLES.products)}</h3>
            <Link to="/products/ideoscreen">IDEOSCREEN</Link>
            <Link to="/products/sceneviz">SCENEVIZ</Link>
            <Link to="/products/aimg">AIMG</Link>
            <Link to="/products/orbo-diya">ORBO DIYA</Link>
            <Link to="/products/baanzon-chat">BAANZON CHAT</Link>
            <Link to="/products/octopus-shield">OCTOPUS SHIELD</Link>
            <Link to="/products/squamed">SQUAMED</Link>
            <Link to="/products/squamed-minime">SQUAMED LITE</Link>
          </div>
          <div className={styles.column}>
            <h3 className={styles.colTitle}>{t(COLUMN_TITLES.services)}</h3>
            <Link to="/build">{t('footer.custom_ai')}</Link>
            <Link to="/build">{t('footer.rd_services')}</Link>
            <Link to="/whitelabel">{t('footer.whitelabel')}</Link>
            <Link to="/deploy">{t('footer.deploy')}</Link>
            <Link to="/build">{t('footer.saas')}</Link>
            <Link to="/products">{t('footer.sector')}</Link>
            <Link to="/demo/schedule">{t('cta.view_demo')}</Link>
          </div>
          <div className={styles.column}>
            <h3 className={styles.colTitle}>{t(COLUMN_TITLES.legal)}</h3>
            <Link to="/privacy-policy">{t('footer.privacy')}</Link>
            <Link to="/terms-of-service">{t('footer.terms')}</Link>
          </div>
        </nav>
      </div>

      <div className={styles.bottomBar}>
        <div className={`container ${styles.bottomInner}`}>
          <p className={`${styles.copyright} tabular-nums`}>
            &copy; {year} Opraiz Technology Pvt Ltd. {t('footer.rights')}
          </p>
          <div className={styles.bottomLinks}>
            <LanguageSwitcher />
            <Link className={styles.legalLink} to="/privacy-policy">
              {t('footer.privacy_short')}
            </Link>
            <Link className={styles.legalLink} to="/terms-of-service">
              {t('footer.terms_short')}
            </Link>
            <Link className={styles.legalLink} to="/login/admin">
              {t('footer.management')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
